<template>
  <InternalLayout>
    <FormSection
      :title="$t('SETTINGS.TWO_STEP_VERIFICATION.TITLE')"
      :description="$t('SETTINGS.TWO_STEP_VERIFICATION.DESCRIPTION')"
    >
      <TwoStepVerificationActivateForm />
    </FormSection>
  </InternalLayout>
</template>

<script>
import TwoStepVerificationActivateForm from './TwoStepVerificationActivateForm.vue';
import FormSection from '@/components/common/layout/FormSection.vue';
import InternalLayout from '@/components/common/layout/InternalLayout.vue';

export default {
  name: 'TwoStepVerificationPage',
  components: {
    TwoStepVerificationActivateForm,
    FormSection,
    InternalLayout,
  },
};
</script>
